import { useCallback, useRef, useMemo } from "react";
import Button, { BUTTON_DISPLAY, BUTTON_SIZE } from "@acadia-ui/button";
import PlatformAdvertiserModal from "../../Modals/PlatformAdvertiserModal";
export default function usePrismaGCMSync({ campaignMetaData, TMEnabled }) {
	const platformAdvertiserModal = useRef(null);

	const triggerHidden = useMemo(() => {
		const isPrisma = campaignMetaData.PlatformName == "Mediaocean (OX)/Prisma";
		return !isPrisma || TMEnabled === false;
	}, [campaignMetaData, TMEnabled]);

	const Trigger = useCallback(() => {
		if (!triggerHidden) {
			return (
				<Button
					// this comment exists to prevent eslint from making this unreadable.
					display={BUTTON_DISPLAY.TEXT}
					size={BUTTON_SIZE.SMALL}
					onClick={() => platformAdvertiserModal.current.triggerOpenClose()}
					data-tracking-id-alt="open-prisma-gcm-sync-modal"
				>
					Verify with Google Campaign Manager
				</Button>
			);
		}
		return <></>;
	}, [triggerHidden]);

	const DisplayedComponent = useCallback(
		() => (
			<PlatformAdvertiserModal
				platformAdvertiserModal={(ref) => {
					platformAdvertiserModal.current = ref;
				}}
				campaignMetaData={campaignMetaData}
			/>
		),
		[campaignMetaData]
	);

	return useMemo(() => [Trigger, DisplayedComponent, triggerHidden], [DisplayedComponent, Trigger, triggerHidden]);
}
